import { createWithEqualityFn } from 'zustand/traditional';

export type SHOP_CODE = 'ex' | 'mi' | 'vt' | 'ap';
interface ThemeStore {
  themeCode: SHOP_CODE;
  setThemeCode: (shopCode: SHOP_CODE) => void;
}

const useThemeStore = createWithEqualityFn<ThemeStore>((set) => ({
  themeCode: 'ex',
  setThemeCode: (code) => set(() => ({ themeCode: code })),
}));

export default useThemeStore;
